// extracted by mini-css-extract-plugin
export default {"root":"Header_root__jVR8H","onTop":"Header_onTop__A8Kuc","placeHolderShimmer":"Header_placeHolderShimmer__mSTgi"};